function Dipespcontratacionestado() {
    return(
        <div className="contenedor">
            <div className="presentacion"> 
               <h1> Presentación </h1>
               <p>
                    El Diploma de Especialización en Contrataciones del Estado 
                    ha sido diseñado para brindar una formación técnica y actualizada 
                    sobre la normativa vigente y los procedimientos que regulan 
                    el Sistema Nacional de Abastecimiento y las contrataciones públicas.
               </p>
               <p>
                    El programa desarrolla contenidos relacionados con la planificación 
                    de contrataciones, actos preparatorios, procedimientos de selección, 
                    ejecución contractual, modificaciones, solución de controversias y 
                    responsabilidades administrativas.
               </p>

                <ul>
                    <h1> Objetivo Específico </h1>
                    <ul>
                        <li>
                            Desarrollar competencias técnicas para aplicar correctamente 
                            la normativa y los procedimientos de las contrataciones públicas, 
                            gestionando procesos de selección y ejecución contractual con 
                            eficiencia, transparencia y cumplimiento del marco legal vigente.
                        </li>
                    </ul>
                </ul>
            </div>

            <div className="metedologia">
                <img 
                    src='/uploads/curs_trabajo_social.jpg' 
                    alt='logo-de-metodologia' 
                    className='logo-metodologia'
                />
                
                <ul> 
                    <li>
                        <h1> Informes </h1>
                        <p>Escuela de Gerencia y Gestión S.A.C</p>
                        <p>📱 Teléfonos y WhatsApp: 913376365 / 948251685</p>
                        <p>📧 Correos: esscuelag@gmail.com | capacita@escuelag.com</p>
                    </li>
                </ul>
            </div>

            <div className="temario-principal">
                <h1> Áreas Temáticas </h1>
                <ul>
                    <li> 1. Planificación de Contrataciones </li>
                    <li> 2. Actos Preparatorios </li>
                    <li> 3. Procedimientos de Selección </li>
                    <li> 4. Ejecución Contractual </li>
                    <li> 5. Modificaciones Contractuales </li>
                    <li> 6. Solución de Controversias </li>
                    <li> 7. Responsabilidades Administrativas </li>
                </ul>
            </div>
        </div>
    );
}
export default Dipespcontratacionestado
